import O1HD from "../../../../../engines/gameEngine";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../BundleResourceConfig";
import oreV2NormalClean from "./oreV2Clean";
import { oreV2Interface, oreV2ObjInterface } from "./oreV2Const";

const {ccclass, property} = cc._decorator;

@ccclass
export default class oreV2ObjItem extends cc.Component {

    @property({type:cc.Node,displayName:"判定点节点"})
    checkNode:cc.Node = null;

    @property({type:cc.Prefab,displayName:"结算预制体"})
    cleanPrefab:cc.Prefab = null;

    @property({type:cc.Node,displayName:"图片节点"})
    spNode:cc.Node = null;

    canClick:boolean = false;

    objData:oreV2ObjInterface = null;

    //
    bindData(objData:oreV2ObjInterface){
        this.objData = objData;
        this.loadSp();
    }

    start(){

        O1HD.on("oreV2ObjItem.checkObjByCircle",this.checkObjByCircle,this);
        O1HD.on("oreV2ObjItem.checkObjByLine",this.checkObjByLine,this);
    }

    loadSp(){
        let spPath:string = this.objData.showSp;
        let bundle = getOneBundleByInstant(BUNDLE_SMALL_NAME.mineLandGameBundle);
        bundle.load(`assets/mineraObj/${spPath}`,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
            if(err){
                console.debug("加载物品图标出错",err);
                return;
            }
            this.spNode.getComponent(cc.Sprite).spriteFrame = asset;
        });
    }

    checkObjByCircle(pos:cc.Vec2,radius:number){
        let pointAry:cc.Vec2[] = [];
        let initPos:cc.Vec2 = this.checkNode.convertToWorldSpaceAR(cc.v2());
        pointAry = [
            cc.v2(initPos.x -this.checkNode.width/2,initPos.y - this.checkNode.height/2),
            cc.v2(initPos.x +this.checkNode.width/2,initPos.y - this.checkNode.height/2),
            cc.v2(initPos.x -this.checkNode.width/2,initPos.y + this.checkNode.height/2),
            cc.v2(initPos.x +this.checkNode.width/2,initPos.y + this.checkNode.height/2),
        ]
        let isTrigger = cc.Intersection.polygonCircle(pointAry,{position:pos,radius:radius});
        if(isTrigger && !this.canClick){
            this.canClick =  isTrigger;
            this.spNode.on("touchend",this.onTouchEnd,this);
            console.log("可以点击????????");
        }
    }

    checkObjByLine(pos : cc.Vec2 , pos2 : cc.Vec2){
        if(cc.Intersection.lineRect( pos , pos2 , this.checkNode.getBoundingBoxToWorld()) && !this.canClick){
            this.canClick = true;
            this.spNode.on("touchend",this.onTouchEnd,this);
            console.log("可以点击????????");
        }
    }
    
    onTouchEnd(e:cc.Event.EventTouch){
        let startPos:cc.Vec2 = e.getStartLocation();
        let currentPos:cc.Vec2 = e.getLocation();
        if(startPos.sub(currentPos).mag() < 10){
            console.log("点击乐乐乐乐了");
            if(this.canClick){
                // 判断为点击 展示收入背包和出售的界面
                this.canClick = false;
                let cleanNode:cc.Node = cc.instantiate(this.cleanPrefab);
                let cs = cleanNode.getComponent(oreV2NormalClean);
                cs.bindNode(this.node);
                cleanNode.setParent(O1HD.Canvas());
            }
        }
    }
}
